<div id="multiselect-sample" class="control-section">
            <ejs-multiselect name="multiselect-checkbox" id='multiselect-checkbox' #multiselect [dataSource]='dataSource' [placeholder]='placeHolder' [fields]='checkFields'  [(ngModel)]="internalValue"
                [mode]='mode'  [popupHeight]='popHeight' [showDropDownIcon]='true' [showSelectAll]="showSelectAll" [filterBarPlaceholder]='filterPlaceholder' (change)="onChange($event)"></ejs-multiselect>
  
</div>


